/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

 /*!
 * EventEmitter v5.2.9 - git.io/ee
 * Oliver Caldwell - https://oli.me.uk/
 */
!function(e){"use strict";function t(){}function n(e,t){for(var n=e.length;n--;)if(e[n].listener===t)return n;return-1}function r(e){return function(){return this[e].apply(this,arguments)}}function i(e){return"function"==typeof e||e instanceof RegExp||!(!e||"object"!=typeof e)&&i(e.listener)}var s=t.prototype,o=e.EventEmitter;s.getListeners=function(e){var t,n,r=this._getEvents();if(e instanceof RegExp){t={};for(n in r)r.hasOwnProperty(n)&&e.test(n)&&(t[n]=r[n])}else t=r[e]||(r[e]=[]);return t},s.flattenListeners=function(e){var t,n=[];for(t=0;t<e.length;t+=1)n.push(e[t].listener);return n},s.getListenersAsObject=function(e){var t,n=this.getListeners(e);return n instanceof Array&&(t={},t[e]=n),t||n},s.addListener=function(e,t){if(!i(t))throw new TypeError("listener must be a function");var r,s=this.getListenersAsObject(e),o="object"==typeof t;for(r in s)s.hasOwnProperty(r)&&-1===n(s[r],t)&&s[r].push(o?t:{listener:t,once:!1});return this},s.on=r("addListener"),s.addOnceListener=function(e,t){return this.addListener(e,{listener:t,once:!0})},s.once=r("addOnceListener"),s.defineEvent=function(e){return this.getListeners(e),this},s.defineEvents=function(e){for(var t=0;t<e.length;t+=1)this.defineEvent(e[t]);return this},s.removeListener=function(e,t){var r,i,s=this.getListenersAsObject(e);for(i in s)s.hasOwnProperty(i)&&-1!==(r=n(s[i],t))&&s[i].splice(r,1);return this},s.off=r("removeListener"),s.addListeners=function(e,t){return this.manipulateListeners(!1,e,t)},s.removeListeners=function(e,t){return this.manipulateListeners(!0,e,t)},s.manipulateListeners=function(e,t,n){var r,i,s=e?this.removeListener:this.addListener,o=e?this.removeListeners:this.addListeners;if("object"!=typeof t||t instanceof RegExp)for(r=n.length;r--;)s.call(this,t,n[r]);else for(r in t)t.hasOwnProperty(r)&&(i=t[r])&&("function"==typeof i?s.call(this,r,i):o.call(this,r,i));return this},s.removeEvent=function(e){var t,n=typeof e,r=this._getEvents();if("string"===n)delete r[e];else if(e instanceof RegExp)for(t in r)r.hasOwnProperty(t)&&e.test(t)&&delete r[t];else delete this._events;return this},s.removeAllListeners=r("removeEvent"),s.emitEvent=function(e,t){var n,r,i,s,o=this.getListenersAsObject(e);for(s in o)if(o.hasOwnProperty(s))for(n=o[s].slice(0),i=0;i<n.length;i++)r=n[i],!0===r.once&&this.removeListener(e,r.listener),r.listener.apply(this,t||[])===this._getOnceReturnValue()&&this.removeListener(e,r.listener);return this},s.trigger=r("emitEvent"),s.emit=function(e){var t=Array.prototype.slice.call(arguments,1);return this.emitEvent(e,t)},s.setOnceReturnValue=function(e){return this._onceReturnValue=e,this},s._getOnceReturnValue=function(){return!this.hasOwnProperty("_onceReturnValue")||this._onceReturnValue},s._getEvents=function(){return this._events||(this._events={})},t.noConflict=function(){return e.EventEmitter=o,t},"function"==typeof define&&define.amd?define(function(){return t}):"object"==typeof module&&module.exports?module.exports=t:e.EventEmitter=t}("undefined"!=typeof window?window:this||{});

/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 */
!function(e){var n;if("function"==typeof define&&define.amd&&(define(e),n=!0),"object"==typeof exports&&(module.exports=e(),n=!0),!n){var t=window.Cookies,o=window.Cookies=e();o.noConflict=function(){return window.Cookies=t,o}}}(function(){function f(){for(var e=0,n={};e<arguments.length;e++){var t=arguments[e];for(var o in t)n[o]=t[o]}return n}function a(e){return e.replace(/(%[0-9A-Z]{2})+/g,decodeURIComponent)}return function e(u){function c(){}function t(e,n,t){if("undefined"!=typeof document){"number"==typeof(t=f({path:"/"},c.defaults,t)).expires&&(t.expires=new Date(1*new Date+864e5*t.expires)),t.expires=t.expires?t.expires.toUTCString():"";try{var o=JSON.stringify(n);/^[\{\[]/.test(o)&&(n=o)}catch(e){}n=u.write?u.write(n,e):encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,decodeURIComponent),e=encodeURIComponent(String(e)).replace(/%(23|24|26|2B|5E|60|7C)/g,decodeURIComponent).replace(/[\(\)]/g,escape);var r="";for(var i in t)t[i]&&(r+="; "+i,!0!==t[i]&&(r+="="+t[i].split(";")[0]));return document.cookie=e+"="+n+r}}function n(e,n){if("undefined"!=typeof document){for(var t={},o=document.cookie?document.cookie.split("; "):[],r=0;r<o.length;r++){var i=o[r].split("="),c=i.slice(1).join("=");n||'"'!==c.charAt(0)||(c=c.slice(1,-1));try{var f=a(i[0]);if(c=(u.read||u)(c,f)||a(c),n)try{c=JSON.parse(c)}catch(e){}if(t[f]=c,e===f)break}catch(e){}}return e?t[e]:t}}return c.set=t,c.get=function(e){return n(e,!1)},c.getJSON=function(e){return n(e,!0)},c.remove=function(e,n){t(e,"",f(n,{expires:-1}))},c.defaults={},c.withConverter=e,c}(function(){})});

var GlobalEvents = new EventEmitter();

(function() {
  
  function positionLanguageSelector() {
    if($(window).width() > 1139) {;
      if($('.gep-switcher').length) {
        $('.gep-switcher').detach().prependTo('.flex-column--selectors')
        $('.flex-column--selectors').addClass('loaded');
        var headerSection = document.getElementById('shopify-section-header');
        if (headerSection) {
          document.documentElement.style.setProperty('--header-height', headerSection.clientHeight + 'px');
        }
      } else {
        setTimeout(() => {
          positionLanguageSelector();
        }, 100);
      }
    }
  }

  $(function() {
    positionLanguageSelector();
  })

  $(window).on('resize', positionLanguageSelector);

  $('[data-action="toggle-search"]').on('click', function() {
  debugger
    $('.MegaMenu').attr('aria-hidden', true);
  })

})();

(function() {
   // your page initialization code here
   // the DOM will be available here
  var elem = document.querySelector('.store-carousel-1');
  if (elem != null) {
    var flkty = new Flickity(elem, {
      // options
    });
  }


  var elem = document.querySelector('.store-carousel-2');
  if (elem != null) { 
    var flkty = new Flickity(elem, {
      // options
    });
  }
  
})();

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();

// Cookies modal

(function() {

  function Self(element, events, options, module) {
    if( !Cookies.get('cookiesmodal') ) {
      show();
    } else {
      set_rakuten_consent();
    }

    events
      .on('cookiesmodalcta:click', function() {
        hide();
        Cookies.set('cookiesmodal', true);
        set_rakuten_consent();
      })
      .on('cookiesmodalclose:click', hide);

    function show() {
      document.documentElement.classList.add('is-active-cookies-modal');
    };

    function hide() {
      document.documentElement.classList.remove('is-active-cookies-modal');
    };

    function set_rakuten_consent() {
      window.__rmcp2 = [1,2,3,4,5,6,7,8,9,10];
      window.__rmuspc = 'YN';
    };
  };

  function Cta(element, events, options, module) {
    element.addEventListener('click', function() {
      events.trigger('cookiesmodalcta:click');
    });
  };

  function Close(element, events, options, module) {
    element.addEventListener('click', function() {
      events.trigger('cookiesmodalclose:click');
    });
  };

  function CookiesModal(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element],
      cta:  element.querySelectorAll('[data-ref-cta]'),
      close:  element.querySelectorAll('[data-ref-close]')
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });

    refs.cta.forEach(function(element) {
      var options = element.getAttribute('data-ref-cta');
          options = JSON.parse(options || '{}');

      Cta(element, events, options, module);
    });

    refs.close.forEach(function(element) {
      var options = element.getAttribute('data-ref-close');
          options = JSON.parse(options || '{}');

      Close(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll('[data-module-cookies-modal]');

  elements.forEach(function(element) {
    var options = element.getAttribute('data-module-cookies-modal');
        options = JSON.parse(options || '{}');

    CookiesModal(element, options);
  });

})();

// Geolocation

(function() {

  // geoip2.country(function(geolocation) {
  //   Cookies.set('geolocation', geolocation);
  //   GlobalEvents.trigger('geolocation', [geolocation]);
  // });

})();

// Hide products with tag from non-EU countries

(function() {

  // Spoof location for testing
  var spoof_location_us = {"continent":{"code":"NA","geoname_id":6255149,"names":{"zh-CN":"???","de":"Nordamerika","en":"North America","es":"Norteamirica","fr":"Amirique du Nord","ja":"?????","pt-BR":"Amirica do Norte","ru":"???????? ???????"}},"country":{"iso_code":"US","geoname_id":6252001,"names":{"zh-CN":"??","de":"USA","en":"United States","es":"Estados Unidos","fr":"Itats-Unis","ja":"???????","pt-BR":"Estados Unidos","ru":"???"}},"registered_country":{"iso_code":"US","geoname_id":6252001,"names":{"en":"United States","es":"Estados Unidos","fr":"Itats-Unis","ja":"???????","pt-BR":"Estados Unidos","ru":"???","zh-CN":"??","de":"USA"}},"traits":{"ip_address":"67.219.150.42","network":"67.219.144.0/20"},"represented_country":{"names":{}}};

  var spoof_location_au = {"continent":{"code":"OC","geoname_id":6255151,"names":{"ja":"?????","pt-BR":"Oceania","ru":"???????","zh-CN":"???","de":"Ozeanien","en":"Oceania","es":"Oceanma","fr":"Ocianie"}},"country":{"iso_code":"AU","geoname_id":2077456,"names":{"ja":"???????","pt-BR":"Australia","ru":"?????????","zh-CN":"????","de":"Australien","en":"Australia","es":"Australia","fr":"Australie"}},"registered_country":{"iso_code":"AU","geoname_id":2077456,"names":{"zh-CN":"????","de":"Australien","en":"Australia","es":"Australia","fr":"Australie","ja":"???????","pt-BR":"Australia","ru":"?????????"}},"traits":{"ip_address":"115.178.23.100","network":"115.178.16.0/21"},"represented_country":{"names":{}}};

  // Set to `false` in production
  var spoof_location = false;

  GlobalEvents.on('geolocation', init);

  window.addEventListener('collection:load-more:success', init);

  $(document).on('Searchanise.ResultsUpdated', init_searchanise_results);

  $(document).on('Searchanise.AutocompleteUpdated', init_searchanise_autocomplete);

  function init() {
    var geolocation = Cookies.getJSON('geolocation');

    if (!geolocation) {
      return;
    }

    if (spoof_location) {
      geolocation = spoof_location;
    }

    console.log('GEOLOCATION:');
    console.log(JSON.stringify(geolocation, null, 2));

    var excluded_product_tags = get_excluded_product_tags(geolocation);

    if (!excluded_product_tags.length) {
      return;
    }

    hide_excluded_product_items(excluded_product_tags);

    product_template_redirect(excluded_product_tags);
  };

  function hide_excluded_product_items(excluded_product_tags) {
    var product_item_elements = Array.from(document.querySelectorAll('[data-module-product-item]'))
      .filter(function(element) {
        var element_options = element.getAttribute('data-module-product-item');
            element_options = JSON.parse(element_options);

        var element_excluded = is_product_excluded(excluded_product_tags, element_options.tags);

        return element_excluded;
      });

    product_item_elements.forEach(function(product_item_element) {
      var grid_cell_element = product_item_element.closest('.Grid__Cell');

      if (grid_cell_element) {
        grid_cell_element.remove();
      }

      product_item_element.remove();
    });
  };

  function product_template_redirect(excluded_product_tags) {
    if (!window.location.href.includes('/products/')) {
      return;
    }

    var product_json_element = document.querySelector('[data-product-json]');

    // Exit if no product JSON found
    if (!product_json_element) {
      return;
    }

    var product_json = JSON.parse(product_json_element.innerHTML);

    // Redirect to homepage if excluded tag found
    var product_excluded = is_product_excluded(excluded_product_tags, product_json.product.tags);

    if (product_excluded) {
      window.location = '/';
    }
  };

  function init_searchanise_results(event, element) {
    hide_searchanise_excluded_product_items(element);
  };

  function init_searchanise_autocomplete(event, input_element, element) {
    hide_searchanise_excluded_product_items(element);
  };

  function hide_searchanise_excluded_product_items(element) {
    var geolocation = Cookies.getJSON('geolocation');

    if (!geolocation) {
      return;
    }

    if (spoof_location) {
      geolocation = spoof_location;
    }

    var excluded_product_tags = get_excluded_product_tags(geolocation);

    if (!excluded_product_tags.length) {
      return;
    }

    var elements = Array.from(element[0].querySelectorAll('.snize-product'))
      .filter(function(element) {
        return excluded_product_tags.some(function(tag) {
          return element.innerHTML.includes(tag);
        });
      });

    elements.forEach(function(element) {
      element.remove();
    });
  };

  function is_product_excluded(excluded_product_tags, product_tags) {
    if (!product_tags) {
      return false;
    }

    return product_tags.some(function(tag) {
      return excluded_product_tags.includes(tag);
    });
  };

  function get_excluded_product_tags(geolocation) {
    var excluded_product_tags = [];

    if (geolocation.continent.code != 'EU') {
      excluded_product_tags.push('EXCLUDE-NON-EU');

      if (geolocation.country.iso_code != 'US') {
        excluded_product_tags.push('EXCLUDE-NON-USA');
      }
    }

    return excluded_product_tags;
  };
  

})();

// // Newsletter Modal

// (function() {

//   var button_element = document.querySelector('[aria-controls="modal-newsletter"]');
  
//   if (!button_element) {
//     return;
//   }
  
//   if (Cookies.get('newsletter-popup')) {
//     return;
//   }
  
//   button_element.click();
//   document.querySelector('#modal-newsletter').ariaHidden = 'false';
  
//   Cookies.set('newsletter-popup', true);
  
//   })();

(function() {
  if (document.getElementById('countdownTimer')) {
    pad = function(n, len) { // leading 0's
      var s = n.toString();
      return (new Array( (len - s.length + 1) ).join('0')) + s;
    };
  
    var timerRunning = setInterval(
      function countDown() {
        var now = new Date();
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        if ( (now.getDay() >= 1) && (now.getDay() <= 5) ) { // Mon - Fri
          var target = 15; // 15:00hrs is the cut-off point
          if (now.getHours() < target) { // don't do anything if we're past the cut-off point
            var hrs = (target - 1) - now.getHours();
            if (hrs < 0) hrs = 0;
            var mins = 59 - now.getMinutes();
            if (mins < 0) mins = 0;
            var secs = 59 - now.getSeconds();
            if (secs < 0) secs = 0;
            var tomorrow = new Date();
            tomorrow.setDate(now.getDate() +1);
            var tomDay = tomorrow.getDay();
            if(tomDay === 0 || tomDay === 6) {
              if(tomDay === 0) {
                tomorrow.setDate(tomorrow.getDate() + 1);
              } else if(tomDay === 6) {
                tomorrow.setDate(tomorrow.getDate() + 2);
              } 
            }
            var nextDate = days[tomorrow.getDay()] + " " + tomorrow.getDate() + " " + months[tomorrow.getMonth()];
            var str = "<span class='promo_product_head'>Order in " + '<strong>' + pad(hrs, 2) + "h " + pad(mins, 2) + "m " + pad(secs, 2) + 's</strong>' + " to receive by <strong>" + nextDate + "</strong></span>";
            document.getElementById('countdownTimer').innerHTML = str;
          }
          //console.log(target);
          if (now.getHours() >= target) {
            document.getElementById('countdownTimer').innerHTML = "<span class='promo_product_head'>Order now and we'll ship next working day</span>";
          }
        }
        else {
          document.getElementById('countdownTimer').innerHTML = "<span class='promo_product_head'>Order now and we'll ship Monday</span>";
        }
      }, 1000
    );
  }
})();

(function() {
  document.addEventListener('DOMContentLoaded', function() {
    var announcementScroll = document.querySelector('.AnnouncementBar__Content--scroll');
    if (announcementScroll == null) return;
    if(announcementScroll.getAttribute('data-flickity-config') == null) return;
    this.initialConfig = Object.assign(JSON.parse(announcementScroll.getAttribute('data-flickity-config')));
    console.log('initial config', this.initialConfig);
    if (announcementScroll.children.length > 1) {
      var announceFlick = new Flickity(announcementScroll, this.initialConfig);

      // Set initial position to be 0
      announceFlick.x = 0;

      // Start the marquee animation
      play();

      // Main function that 'plays' the marquee.
      function play() {
        announceFlick.x = announceFlick.x - 1.5;
        announceFlick.settle(announceFlick.x);
        requestId = window.requestAnimationFrame(play);
      }

      // Main function to cancel the animation.
      function pause() {
        if (requestId) {
          window.cancelAnimationFrame(requestId)
          requestId = undefined;
        }
      }

      // Pause on mouse over / focusin
      announcementScroll.addEventListener('mouseover', pause, false);
      announcementScroll.addEventListener('focusin', pause, false);

      // Unpause on mouse out / focusout
      announcementScroll.addEventListener('mouseout', play, false);
      announcementScroll.addEventListener('focusout', play, false);

    }
  });
})();

// Form submit on change

(function() {

  function Self(element, events, options, module) {
    Array.from(element.elements).forEach(function(form_element) {
      form_element.addEventListener('change', function() {
        element.submit();
      });
    });
  };

  function FormSubmitOnChange(element, options) {
    var defaults = {};

    options = Object.assign({}, defaults, options);

    var events = new EventEmitter();

    var refs = {
      self: [element]
    };

    var module = {
      element: element,
      options: options,
      refs: refs
    };

    refs.self.forEach(function(element) {
      var options = module.options;

      Self(element, events, options, module);
    });
  };

  var elements = document.querySelectorAll('[data-module-form-submit-on-change]');

  elements.forEach(function(element) {
    var options = element.getAttribute('data-module-form-submit-on-change');
        options = JSON.parse(options || '{}');

    FormSubmitOnChange(element, options);
  });

})();

class ComplementaryProducts extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
  
        fetch(this.dataset.complimentaryUrl)
          .then(response => response.json())
          .then(res => {
            if(res.products.length) {
              console.log('res complimentary: ', res);
              document.querySelector('.also_title').style.display = 'block';
              res.products.forEach(product => {
                const template = document.querySelector('#also_template').content.cloneNode(true).children[0];
                const img = document.createElement('img');
                template.querySelector('[data-complementary-url]').href = product.url;
                template.querySelector('[data-complementary-url]').title = product.title;
                img.src = product.featured_image.replace('.jpg', '_400x400.jpg').replace('.png', '_400x400.png');
                img.alt = product.title;
                img.classList.add('main-prod-img');
                template.querySelector('[data-complementary-image]').appendChild(img);
                this.appendChild(template);
              })
            } else {
              document.querySelectorAll('.also_metafields_wrapper').length ? document.querySelector('.also_title').style.display = 'block' : '';
              document.querySelectorAll('.also_metafields_wrapper').length ? document.querySelectorAll('.also_metafields_wrapper')[0].style.display = 'block' : '';
            }
          })
          .catch(e => {
            console.error(e);
            document.querySelector('.also_wrapper').style.display = 'none';
          });
      }
  
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  }
  
  customElements.define('complementary-products', ComplementaryProducts);
  
  class RelatedProducts extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
  
        fetch(this.dataset.relatedUrl)
          .then(response => response.json())
          .then(res => {
            if(res.products.length) {
              console.log('res related: ', res);
              document.querySelector('.related_title').style.display = 'block';
              res.products.forEach(product => {
                const template = document.querySelector('#also_template').content.cloneNode(true).children[0];
                const img = document.createElement('img');
                template.querySelector('[data-complementary-url]').href = product.url;
                template.querySelector('[data-complementary-url]').title = product.title;
                img.src = product.featured_image.replace('.jpg', '_400x400.jpg').replace('.png', '_400x400.png');
                img.alt = product.title;
                img.classList.add('main-prod-img');
                template.querySelector('[data-complementary-image]').appendChild(img);
                this.appendChild(template);
              })
            }
          })
          .catch(e => {
            console.error(e);
            document.querySelector('.also_wrapper').style.display = 'none';
          });
      }
  
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
    }
  }
  
customElements.define('related-products', RelatedProducts);
  
document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  if (!variant.available) {
    // setTimeout(() => $('.klaviyo-bis-trigger')[0].click(), 10);
    $('.klaviyo-bis-trigger').show();
  } else {
    $('.klaviyo-bis-trigger').hide();
  }
});

(function () {
  function getClosest(elem, selector) {
    // Element.matches() polyfill
    if (!Element.prototype.matches) {
        Element.prototype.matches =
            Element.prototype.matchesSelector ||
            Element.prototype.mozMatchesSelector ||
            Element.prototype.msMatchesSelector ||
            Element.prototype.oMatchesSelector ||
            Element.prototype.webkitMatchesSelector ||
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i = matches.length;
                while (--i >= 0 && matches.item(i) !== this) {}
                return i > -1;
            };
    }
    // Get the closest matching element
    for ( ; elem && elem !== document; elem = elem.parentNode ) {
      if ( elem.matches( selector ) ) return elem;
    }
    return null;
  };

  function toggleReadMore(e) {
    const parentElem = getClosest(e.currentTarget, '.SectionHeader__Description');
    const readMore = parentElem.querySelector('.readMore');
    const readLess = parentElem.querySelector('.readLess');
    if (readMore.classList.contains('open')) {
      readMore.classList.remove('open');
      readLess.classList.remove('open');
    } else {
      readMore.classList.add('open');
      readLess.classList.add('open');
    }
  }
  const readMoreLink = document.querySelectorAll('[data-read-more]');
  const readLessLink = document.querySelectorAll('[data-read-less]');
  if (!readMoreLink) return;
  readMoreLink.forEach(function (elem) {
    elem.addEventListener('click', toggleReadMore)
  });
  if (!readLessLink) return;
  readLessLink.forEach(function (elem) {
    elem.addEventListener('click', toggleReadMore)
  })
})();
